import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React from 'react';
import { CheckboxActive } from '../../../components/icons/CheckboxActive';
import { dynamicInput } from '../../../styles/mixins';
import { typography } from '../../../styles/typography';

const CheckboxHost = styled.div`
  position: relative;
`;

const CheckboxInput = styled.input`
  ${dynamicInput}
`;

const dynamicLabel = (props: any) => css`
  position: relative;
  padding-left: 45px;

  cursor: pointer;
  white-space: pre-wrap;
  display: block;
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0px;
    width: 28px;
    height: 28px;
    border-radius: 1px;
    background-color: ${props.theme.colors.background};
    border: 1px solid ${props.disabled ? '#a0a0a0' : props.theme.colors.primary};
    border-width: ${props.bordered ? '1px' : '0px'};
    border-radius: 1px;
    background-color: ${props.checked
      ? props.disabled
        ? '#a0a0a0'
        : props.theme.colors.primary
      : props.theme.colors.background};
  }
  &:hover::before {
    background-image: url('data:image/svg+xml;utf8,<svg width="16px" height="15px" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg" ><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Assets" transform="translate(-347.000000, -1288.000000)" stroke="%2372DCEB" stroke-width="2"><polyline id="icon-check-hover" transform="translate(355.000000, 1295.000000) scale(-1, 1) rotate(-180.000000) translate(-355.000000, -1295.000000) " points="348 1295.46154 353.5 1289 362 1301"></polyline></g></g></svg>');
    background-repeat: no-repeat;
    background-size: 16px;
    background-position: center;
  }
`;

const Label = styled.label<{
  checked: boolean;
  disabled: boolean;
  bordered?: boolean;
}>`
  ${dynamicLabel}
  ${typography.body}
  line-height: 28px;
  height: 28px;
`;

const CheckboxSvg = styled(CheckboxActive)`
  position: absolute;
  left: 0;
  top: 0;
`;

export interface IProps {
  checked: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  id: string;
  label: string;
  bordered?: boolean;
}

export const CheckboxRadio: React.FC<IProps> = ({
  checked,
  onChange,
  id,
  label,
  bordered,
  disabled,
  ...rest
}: IProps) => {
  return (
    <CheckboxHost {...rest}>
      <CheckboxInput
        id={`radio_${label}_${id}`}
        type="radio"
        checked={checked}
        disabled={disabled}
        onChange={() => {
          if (onChange) {
            onChange(!checked);
          }
        }}
      />
      <Label
        htmlFor={`radio_${label}_${id}`}
        checked={checked}
        bordered={bordered}
        disabled={disabled ?? false}
      >
        {checked && <CheckboxSvg height="28px" width="28px" />}
        {label}
      </Label>
    </CheckboxHost>
  );
};
